module.exports = __webpack_public_path__ + "img/sertifikat-circle.dc7ef76f.png";